import React, { useEffect, useMemo, useState } from "react";
import { CardElement, Elements, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Head from "next/head";


const stripePromise = loadStripe(process.env.NEXT_PUBLIC_PAYMENT_PUBLIC_KEY);

const PaymentForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [snakbaropen, setSnakbarOpen] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("");

  const [paymentFormDone, setPaymentFormDone] = useState(false);




  useEffect(() => {
    if (props.getCardInputValue.clicked && paymentFormDone) {
      handleSubmit()
    }
  }, [paymentFormDone, props.getCardInputValue.clicked])





  useEffect(() => {
    if (snakbaropen) {
      setTimeout(() => {
        setSnakbarOpen(false);
      }, 2000);
    }
  }, [snakbaropen]);





  const handleSubmit = async () => {

    if (!stripe || !elements) {
      return;
    }
    const billingDetails = {
      name: props.getCardInputValue.paymentObjectData.billing_name,
      email: props.getCardInputValue.paymentObjectData.billing_email,
      address: {
        city: props.getCardInputValue.paymentObjectData.billing_city,
        line1: props.getCardInputValue.paymentObjectData.address_line_1,
        state: props.getCardInputValue.paymentObjectData.billing_state,
        postal_code: props.getCardInputValue.paymentObjectData.billing_zip,
      },
    };

    const cardElement = elements.getElement(CardElement);

    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: billingDetails,
      });
      if (error) {
        props.getCardInputValue?.paymentID(error);
      } else {
        props.getCardInputValue?.paymentID(paymentMethod);
      }
    } catch (error) {
      setSnackBarMsg("An error occurred. Please try again.");
      props.getCardInputValue?.paymentID(null);
    }
  };





  const getValues = (e) => {
    let obj = { ...props.getCardInputValue.cardFormFielddata }

    if (e.complete === true) {
      obj['complete'] = true
    } else {
      obj['complete'] = false
    }

    if (e.error === undefined) {
      if (obj.cardnumbe) {
        delete obj.cardnumbe
      }
      if (obj.card_expiry) {
        delete obj.card_expiry
      }
      if (obj.card_cvv) {
        delete obj.card_cvv
      }
    }

    if (e) {
      if (e.error) {
        if (e.error.code === "incomplete_number" || e.error.code === "invalid_number") {
          obj['cardnumbe'] = e.error.message
        } else {
          if (obj.cardnumbe) {
            delete obj.cardnumbe
          }
        }

        if (e.error.code === "incomplete_expiry" || e.error.code === "invalid_expiry_year_past" || e.error.code === "invalid_expiry_year") {
          obj['card_expiry'] = e.error.message
        } else {
          if (obj.card_expiry) {
            delete obj.card_expiry
          }
        }


        if (e.error.code === "incomplete_cvc") {
          obj['card_cvv'] = e.error.message
        } else {
          if (obj.card_cvv) {
            delete obj.card_cvv
          }
        }

      }
    }
    if ((e.complete === true) && (e.error === undefined)) {
      setPaymentFormDone(true)
    }
    props.getCardInputValue.userdataModifier(obj)
  };





  return (
    <>

      <Head>
        <title>Secure Payment - Complete Your Enrollment | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Secure Payment, Credit Card Payment, Complete Enrollment, Finalize Order, School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="Complete Your Secure Payment | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/secure_payment_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="A banner for the School of Our Divine Infinite Being, leading to the secure payment page for course enrollment and certification."
        ></meta>
        <meta
          property="og:description"
          content="Securely provide your payment information to complete your enrollment or purchase. Our payment process is safe and encrypted to protect your data."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/diviner-signup/CardElement"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/secure_payment_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="A banner for the School of Our Divine Infinite Being, leading to the secure payment page for course enrollment and certification."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/diviner-signup/CardElement"
        ></meta>
        <meta
          name="twitter:title"
          content="Complete Your Secure Payment | School of Our Divine Infinite Being"
        ></meta>
        <meta
          name="twitter:description"
          content="Securely provide your payment information to complete your enrollment or purchase. Our payment process is safe and encrypted to protect your data."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/diviner-signup/CardElement" />
      </Head>
      <div className="stripeCard">
        {/* Card Details44 */}
        <div className="custom-card-element">
          <CardElement
            className="cardElementClass"
            options={{
              style: {
                base: {
                  iconColor: "#c4f0ff",
                  color: "#000",
                  fontWeight: "500",
                  fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                  fontSize: "16px",
                  fontSmoothing: "antialiased",
                  ":-webkit-autofill": {
                    color: "#fce883",
                  },
                  "::placeholder": {
                    color: "#064487",
                  },
                  padding: "25px",
                  lineHeight: "50px",
                  backgroundColor: "#fff",
                },
                invalid: {
                  color: "red",
                },
              },
              disableLink: true,
              hidePostalCode: true,
            }}
            onChange={getValues}
          />

        </div>
      </div>

    </>
  );
};

const PaymentComponent = (props) => {
  console.log("props", props);
  return (

    <>

      <Elements stripe={stripePromise}>
        <PaymentForm getCardInputValue={props} />
      </Elements>
    </>
  );
};

export default PaymentComponent;
